// import HttpReq from 'Helper/AxiosRequest';
import { baseUrl } from 'Helper';
import axios from 'axios';

// let http = new HttpReq(baseUrl);

// export const apiRequest = async ({ method = 'get', url, payload, action }) => {
//   try {
//     let { data } = await http[method](url, payload);
//     return action ? { data: action(data) } : { data }
//   }
//   catch ({ message }) {
//     throw new Error(message)
//   }
// };


export const apiRequest = async ({
  method = 'get',
  url,
  payload={},
  params={},  // pass url search parameters as object
  contentType = "application/json",
  extraHeader = {},
  action=null
}) => {
  const token = localStorage.getItem('__ra_pos');
  // console.log(token)
  // const myHeaders = new Headers();
  // myHeaders.append("Authorization", `Bearer ${token}`,)
  // myHeaders.append("Content-Type", contentType,)
  // myHeaders.append("Accept", "application/json")
  const axiosInstance = axios.create({
    baseURL: baseUrl,
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": contentType,
      // "Accept": "application/json",
      ...extraHeader
    }
  });

  // console.log({contentType})
  try {
    const { data } = await axiosInstance({
      method,
      url,
      data: payload,
      params,
      action,

    })
    return action ? { data: action(data) } : { data }
  } catch (error) {
    const errors = error?.response?.data?.error
    console.log(error)
    const message = Object.values(errors || {}).flat()
    if (message?.length) throw new Error(JSON.stringify({
      message: message,
      status: error?.response?.status,
      statusText: error?.response?.statusText
    }))
    else
      throw new Error(error)
  }
}
